var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      ref: "popover",
      attrs: {
        placement: _vm.placement,
        width: _vm.popoverWidth,
        "popper-class": "no-padding-popover",
        trigger: "click",
      },
      model: {
        value: _vm.popoverVisible,
        callback: function ($$v) {
          _vm.popoverVisible = $$v
        },
        expression: "popoverVisible",
      },
    },
    [
      _vm.popoverContentShow
        ? _c(
            "div",
            [
              _c(
                "employee-department",
                _vm._b(
                  {
                    ref: "employeeDepartment",
                    on: { select: _vm.popoverSubmit },
                  },
                  "employee-department",
                  _vm.$attrs,
                  false
                )
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "popover-footer" },
                [
                  _vm.activeTabName === "user"
                    ? _vm._t("user-footer")
                    : _vm._t("dep-footer"),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.popoverVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  !_vm.isRadio
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.popoverSubmit },
                        },
                        [_vm._v("确 定")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          style: { display: _vm.contentBlock ? "block" : "inline-block" },
          attrs: { slot: "reference" },
          on: { click: _vm.showContentClick },
          slot: "reference",
        },
        [_vm._t("membersDep")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }